<template lang="pug">
  div.navbar-section
    .dropdown.dropdown-right.d-flex
      a.decoration-off.flex-centered.dropdown-toggle(:href='`#${$route.path}`')
        .loading.loading-lg.avatar-lg(v-if="loadingUser")
        user-avatar.avatar-lg(:user='currentUser' v-else)
        i.fas.fa-caret-down
      ul.menu
        li
          .app-logo
            .loading.loading-lg.flex-centered(v-if="loadingUser")
            .d-flex(v-else)
              div
                user-avatar.avatar-user(:user="currentUser")
              .user-info
                .text-ellipsis {{ currentUser.fullName }}
                .user-email.text-ellipsis {{ currentUser.email }}

        li.divider.text-center
        li
          a.c-hand.decoration-off(@click="confirmSignOut")
            i.icon.icon-shutdown
            span.label-signout Sair
</template>

<script>
import UserAvatar from '../helpers/UserAvatar'
import authService from '@/services/auth'
import AuthManager from '@/lib/AuthManager'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      loadingUser: false,
      userHover: false,
    }
  },

  components: { UserAvatar },

  computed: {
    ...mapState('user', ['currentUser']),
  },

  methods: {
    ...mapActions('user', ['fetchCurrentUser']),

    confirmSignOut() {
      const options = {
        size: 'sm',
        title: 'Confirmar',
        cancelLabel: 'Cancelar',
      }
      this.$dialogs
        .confirm('Tem certeza que deseja sair?', options)
        .then(res => {
          if (res.ok) {
            this.signOut()
          }
        })
    },

    async signOut() {
      try {
        await authService.signOut()
        this.$router.replace({ name: 'auth.signIn' })
      } catch (e) {
        this.$toaster.error(e.message)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../styles/_colors.styl'
i.fas.fa-caret-down
  font-size 20px
  margin-left 10px
  align-self center

.decoration-off
  margin-left 10px
  box-shadow none
  text-decoration none

.app-logo
  padding 0.5rem

.dropdown-toggle
  box-shadow none

.menu
  width 300px
  max-height 100vh
  overflow hidden

.label-signout
  margin-left 10px

.avatar-user
  font-size 30px
  min-height 50px
  min-width 50px

.user-info
  max-width 200px
  margin-left 20px

  .user-email
    font-size 14px


.loading.loading-lg.avatar-lg
  margin-right 15px

@media(max-width 335px)
  ul.menu
    width 270px
</style>
